import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FieldComponent } from '../field/field.component';
import { ServiceStock } from '../service-stock.service';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.css']
}) 
export class RadioButtonComponent extends FieldComponent implements OnInit, OnDestroy {

  constructor(services: ServiceStock) {
    super(services);
  }

  // @Input() radioOptions: any=[];
  // @Input() StateOptions :any = [];

  @Input('type') type: number = 1;      // Static or Dynamic
  @Input('optionAlignment') optionAlignment: string = 'horizontal';
  @Input('staticOptions') staticOptions : string ;

  private loadOptions$: Subject<void> = new Subject<void>();
  private unsubscribe$ = new Subject<void>();
  public JSON = JSON;
  radioOptions = new class {  
    options: { id: string, text: string }[] = [];
    loading: boolean = false;
  }();

  ngOnInit() { 
    if(this.staticOptions){
    this.staticOptions = JSON.parse(this.staticOptions);
    } else{

    
    this.loadOptions$.pipe(
      debounceTime(500),
      takeUntil(this.unsubscribe$),
      switchMap(() => {
        this.radioOptions.loading = true;
        this.clearError();
        return this.services.http.loadLookup(this.domainObjectUrl, this.dependencyMap, 0, undefined, 10, this.doServerUrl,undefined);
      }
      )).subscribe(
        response => {
          if (response && response['Data']) {
            this.radioOptions.options = response['Data'];
          }
          this.radioOptions.loading = false;
        },
        err => {
          this.radioOptions.loading = false;
          this.setError("Error while loading options");
          console.error("Domain Object Configuration Error\nField Id: " + this.fieldID + "\nDomain Object Code: " + this.domainObjectCode);
        }
      );
      
  }
}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  setDependency(key, value) {
    if (this.dependencyMap.get(key) == undefined) { return; }
    var previousVal = this.getDependency(key);
    this.dependencyMap.get(key).value = value;
    if (previousVal != value) {
      this.loadOptions();
    }
  }

  ngAfterViewInit() {
    this.loadOptions();
  }

  async loadOptions() {
    if (this.doCustomScript) {
      await this.doCustomScript();
    }
    if (this.doCustomFilter) {
      await this.doCustomFilter();
    }
    this.loadOptions$.next();
  }

  // // async loadOptions() {
  // //   this.radioOptions.loading = true;
  // //   if (this.doCustomScript) {
  // //     await this.doCustomScript();
  // //   }
  // //   this.services.http.loadLookup(this.domainObjectUrl, this.dependencyMap, 0, undefined, 10, this.doServerUrl).subscribe(
  // //     response => {
  // //       if (response && response['Data']) {
  // //         this.radioOptions.options = response['Data'];
  // //       }
  // //     },
  // //     err => {
  // //       console.error("Domain Object Configuration Error\nField Id: " + this.fieldID + "\nDomain Object Code: " + this.domainObjectCode);
  // //     },
  // //     () => {
  // //       this.radioOptions.loading = false;
  // //     });
  // // }

  onChangeBlur(id, text) {
    this.isOnFocus = false;
    this.additionalInfo = text;
    this.change.emit();
    this.blur.emit(this.value);

  }

  setValue(value) {
    this.value = value;
    let opt = this.radioOptions.options.find((opt) => { return (opt.id == value) })
    if (opt != undefined) {
      this.additionalInfo = opt.text;
      
    } 
  }

  // // setValue(value, description = undefined) {
  // //   this.value = value;
  // //   if (description != undefined) {
  // //     this.additionalInfo = description;
  // //   } else {
  // //     let opt = this.radioOptions.options.find((opt) => { return (opt.id == value) })
  // //     this.additionalInfo = opt.text;
  // //   }
  // // }


  fieldReset() {
    this.radioOptions.options = [];
    this.radioOptions.loading = false;
    this.loadOptions();
  }

}
